export default __webpack_public_path__ + "static/media/3.0941b896.webp";